// extracted by mini-css-extract-plugin
export default {"editorial":"Editorial_editorial__pfxRo"};